"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addGroupBuy = addGroupBuy;
exports.checkValidDate = checkValidDate;
exports.queryGroupBuyDetail = queryGroupBuyDetail;
exports.queryGroupBuyPage = queryGroupBuyPage;
exports.toggleEnable = toggleEnable;
exports.updateGroupBuy = updateGroupBuy;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
var querestUrl = '/xyGoodsActivityGroupBuy';

// 验证拼单优惠日期
function checkValidDate(data) {
  return (0, _requestPIM.default)({
    url: querestUrl + '/checkValidDate',
    method: 'put',
    data: data
  });
}

// 获取拼单优惠分页列表
function queryGroupBuyPage(query) {
  return (0, _requestPIM.default)({
    url: querestUrl + '/page',
    method: 'get',
    params: query
  });
}

// 获取拼单优惠详情
function queryGroupBuyDetail(id) {
  return (0, _requestPIM.default)({
    url: querestUrl + '/' + id,
    method: 'get'
  });
}

// 添加拼单优惠
function addGroupBuy(data) {
  return (0, _requestPIM.default)({
    url: querestUrl,
    method: 'post',
    data: data
  });
}
// 修改拼单优惠
function updateGroupBuy(data) {
  return (0, _requestPIM.default)({
    url: querestUrl,
    method: 'put',
    data: data
  });
}

// 快捷切换活动启用状态
function toggleEnable(fnId, markForEnable) {
  return (0, _requestPIM.default)({
    url: querestUrl + '/toggleEnable',
    method: 'put',
    params: {
      fnId: fnId,
      markForEnable: markForEnable
    }
  });
}